import axios from "axios";
import { Modal } from "antd";
import { AiOutlineExclamation } from "react-icons/ai";
import { Cookies } from "react-cookie";
import "./auth.scss";
const instance = axios.create();

let merchantNotExist = false;

let isModalOpen = false;

const cookies = new Cookies();

const handleCancel = () => {
  cookies.remove("token", { path: "/" });
  window.location.reload();
  Modal.destroyAll();
  window.location.href = "/";
};

instance.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401) &&
      error.response.status !== 400 &&
      error.response.status !== 404 &&
      !isModalOpen
    ) {
      if (
        error.response.data.message ===
        "You do not have the required role to perform this action"
      ) {
        merchantNotExist = true;
      }

      isModalOpen = true;

      Modal.error({
        content: (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                background: "#f8d7da",
                color: "#d9534f",
                padding: 10,
                borderRadius: "50%",
                fontSize: 24,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 40,
                height: 40,
              }}
            >
              <AiOutlineExclamation />
            </div>
            <div style={{ marginTop: 10 }}>
              {merchantNotExist ? (
                <>
                  <h3 style={{ fontSize: 18, fontWeight: "bold" }}>
                    Access Denied.
                  </h3>
                  <h3 style={{ fontSize: 16.7, fontWeight: "bold" }}>
                  User not found. Please enter valid credentials.
                  </h3>
                </>
              ) : (
                <>
                  <h3 style={{ fontSize: 18, fontWeight: "bold" }}>
                    Session expired
                  </h3>
                  <p style={{ color: "#666", marginTop: 5 }}>
                    Your current session has expired, and you have been logged
                    out. Please log in again to continue.
                  </p>
                </>
              )}
            </div>
            <div style={{ marginTop: 15 }}>
              <button
                style={{
                  backgroundColor: "#333",
                  color: "white",
                  padding: "8px 16px",
                  border: "none",
                  borderRadius: 5,
                  cursor: "pointer",
                  transition: "background 0.3s",
                }}
                onClick={handleCancel}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#d6ad61")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#333")}
              >
                Go Back to Login
              </button>
            </div>
          </div>
        ),

        centered: true,
        cancelButtonProps: { style: { display: "none" } },
        okButtonProps: { style: { display: "none" } },
        closable: false,

        onOk: () => {
          isModalOpen = false;
        },

        onCancel: () => {
          isModalOpen = false;
        },
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
